// extracted by mini-css-extract-plugin
export default {"link":"LL-z","disabled":"ML-z"};